export default __webpack_public_path__ + "static/media/imgFour.51c80471.png";